import { mergeStyles } from "office-ui-fabric-react";
import { DefaultButton } from "office-ui-fabric-react/lib/Button";
import {
  Dialog,
  DialogFooter,
} from "office-ui-fabric-react/lib/Dialog";
import React from "react";
import { useTranslation } from "react-i18next";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { clearAlerts } from "../../../config/redux/alerts/alertsActions";

const errS = mergeStyles({
  color: 'red'
})

const RealizationError: React.FC = () => {
  const { t } = useTranslation("admin");
  const { dialogError } = useSelector((state: RootStateOrAny) => state.alerts);
  const dispatch = useDispatch();

  const dismiss = async () => {
    dispatch(clearAlerts());
  };

  return (
    <Dialog
      hidden={!dialogError}
      onDismiss={dismiss}
      title={dialogError ? dialogError.title : t("orders.realizationError.missingData") as string}
      closeButtonAriaLabel={t("nav.close") as string}
    >
      <>
        <p className={errS}>{dialogError ? dialogError.message : "."}</p>
        <DialogFooter>
          <DefaultButton onClick={dismiss} text={t("orders.realizationError.close") as string} />
        </DialogFooter>
      </>
    </Dialog>
  );
};

export default RealizationError;